<template>
  <div class="slide">
    <ul class="slide-wrapper">
      <li @click="changeBodyContent(0)">
        <div class="slide-item" :style="(activeIndex == 0)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.homeSrc" />
          <span class="item-right">主页</span>
        </div>
      </li>
      <li @click="changeBodyContent(2)">
        <div class="slide-item" :style="(activeIndex == 2)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.memberSrc" />
          <span class="item-right">我的会员</span>
        </div>
      </li>
      <li @click="changeBodyContent(3)">
        <div class="slide-item" :style="(activeIndex == 3)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.promoteSrc" />
          <span class="item-right">推广订单</span>
        </div>
      </li>
      <li @click="changeBodyContent(10)">
        <div class="slide-item" :style="(activeIndex == 10)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.memberSortSrc" />
          <span class="item-right">会员排名</span>
        </div>
      </li>
      <li @click="changeBodyContent(4)">
        <div class="slide-item" :style="(activeIndex == 4)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.wechatSrc" />
          <span class="item-right">公众号授权</span>
        </div>
      </li>
      <li @click="changeBodyContent(5)">
        <div class="slide-item" :style="(activeIndex == 5)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.activationSrc" />
          <span class="item-right">激活续费</span>
        </div>
      </li>
      <li @click="changeBodyContent(6)">
        <div class="slide-item" :style="(activeIndex == 6)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.withdrawSrc" />
          <span class="item-right">提现记录</span>
        </div>
      </li>
      <li @click="changeBodyContent(7)">
        <div class="slide-item" :style="(activeIndex == 7)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.setSrc" />
          <span class="item-right">设置</span>
        </div>
      </li>
      <li @click="changeBodyContent(1)">
        <div class="slide-item" :style="(activeIndex == 1)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.inviteSrc" />
          <span class="item-right">网站推广</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { Modal } from 'view-design'
  import slideActiveImg from '@/assets/img/official/slide_active.png'
  import officialBtnHomeN from '@/assets/img/official/leftbar_btn_homepage_n.png'
  import officialBtnHomeS from '@/assets/img/official/leftbar_btn_homepage_s.png'
  import officialBtnInviteN from '@/assets/img/official/leftbar_btn_invite_n.png'
  import officialBtnInviteS from '@/assets/img/official/leftbar_btn_invite_s.png'
  import officialBtnMemberN from '@/assets/img/official/leftbar_btn_member_n.png'
  import officialBtnMemberS from '@/assets/img/official/leftbar_btn_member_s.png'
  import officialBtnPromoteN from '@/assets/img/official/leftbar_btn_tuiguang_n.png'
  import officialBtnPromoteS from '@/assets/img/official/leftbar_btn_tuiguang_s.png'
  import officialBtnMemberSortN from '@/assets/img/official/leftbar_btn_member_sort_n.png'
  import officialBtnMemberSortS from '@/assets/img/official/leftbar_btn_member_sort_s.png'
  import officialBtnWechatN from '@/assets/img/official/leftbar_btn_wechat_n.png'
  import officialBtnWechatS from '@/assets/img/official/leftbar_btn_wechat_s.png'
  import officialBtnActivationN from '@/assets/img/official/leftbar_btn_activation_n.png'
  import officialBtnActivationS from '@/assets/img/official/leftbar_btn_activation_s.png'
  import officialBtnWithdrawN from '@/assets/img/official/leftbar_btn_withdrawal_n.png'
  import officialBtnWithdrawS from '@/assets/img/official/leftbar_btn_withdrawal_s.png'
  import officialBtnSetN from '@/assets/img/official/leftbar_btn_set_n.png'
  import officialBtnSetS from '@/assets/img/official/leftbar_btn_set_s.png'
  import { getHasPackage } from '@/utils/auth'
  export default {
    name: "SildeNav",
    components: {},
    data: function() {
      return {
        activeStyleObj: {
          backgroundImage: 'url(' + slideActiveImg + ')',
          color: '#fff'
        },
        slideImgObj: {
          homeSrc: officialBtnHomeS,
          inviteSrc: officialBtnInviteN,
          memberSrc: officialBtnMemberN,
          promoteSrc: officialBtnPromoteN,
          memberSortSrc: officialBtnMemberSortN,
          wechatSrc: officialBtnWechatN,
          activationSrc: officialBtnActivationN,
          withdrawSrc: officialBtnWithdrawN,
          setSrc: officialBtnSetN,
        },
        hasPackage: getHasPackage() === 'true' ? true : false
      }
    },
    watch: {
      activeIndex: function() {
        this.initImgSrc()
      },
      $route: function(to,from){
        this.hasPackage = (getHasPackage() === 'true')
        if (this.hasPackage === false) {
          this.$router.push('/pc/official/dialog')
          this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 5)
        }
      }
    },
    computed: {
      activeIndex: function(){
        return this.$store.getters.officialAccountActiveIndex
      }
    },
    mounted: function() {
      var path = this.$route.path
      var activeIndex
      switch (path) {
        case '/pc/official/statistics':
          activeIndex = 0
          break;
        case '/pc/official/invite':
          activeIndex = 1
          break;
        case '/pc/official/member':
          activeIndex = 2
          break;
        case '/pc/official/order':
          activeIndex = 3
          break;
        case '/pc/official/sort':
          activeIndex = 10
          break;
        case '/pc/official/authorization':
          activeIndex = 4
          break;
        case '/pc/official/dialog':
          activeIndex = 5
          break;
        case '/pc/official/withdraw':
          activeIndex = 6
          break;
        case '/pc/official/set':
          activeIndex = 7
          break;
        default:
          activeIndex = 0
      }
      this.$store.dispatch('nav/changeOfficialAccountActiveIndex', activeIndex)
      if(this.$pc && this.$store.getters.personalActiveIndex === 'undefined') {
        this.changeBodyContent(activeIndex)
      } else {
        this.hasPackage = (getHasPackage() === 'true')
        if (this.hasPackage === false && activeIndex !== 5) {
          this.$router.push('/pc/official/dialog')
          this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 5)
        }
      }
    },
    methods: {
      initImgSrc: function() {
        this.slideImgObj = {
          homeSrc: (this.activeIndex == 0) ? officialBtnHomeS : officialBtnHomeN,
          inviteSrc: (this.activeIndex == 1) ? officialBtnInviteS : officialBtnInviteN,
          memberSrc: (this.activeIndex == 2) ? officialBtnMemberS : officialBtnMemberN,
          promoteSrc: (this.activeIndex == 3) ? officialBtnPromoteS : officialBtnPromoteN,
          memberSortSrc: (this.activeIndex == 10) ? officialBtnMemberSortS : officialBtnMemberSortN,
          wechatSrc: (this.activeIndex == 4) ? officialBtnWechatS : officialBtnWechatN,
          activationSrc: (this.activeIndex == 5) ? officialBtnActivationS : officialBtnActivationN,
          withdrawSrc: (this.activeIndex == 6) ? officialBtnWithdrawS : officialBtnWithdrawN,
          setSrc: (this.activeIndex == 7) ? officialBtnSetS : officialBtnSetN
        }
      },
      changeBodyContent: function(activeIndex) {
        var url = ''
        switch (activeIndex) {
          /* case 0:
            url = '/official/invite'
            break; */
          case 0:
            url = '/pc/official/statistics'
            break;
          case 1:
            url = '/pc/official/invite'
            break;
          case 2:
            url = '/pc/official/member'
            break;
          case 3:
            url = '/pc/official/order'
            break;
          case 10:
            url = '/pc/official/sort'
            break;
          case 4:
            url = '/pc/official/authorization'
            break;
          case 5:
            url = '/pc/official/dialog'
            break;
          case 6:
            url = '/pc/official/withdraw'
            break;
          case 7:
            url = '/pc/official/set'
            break;
          default:
            //url = '/official/invite'
            url = '/pc/official/statistics'
        }
        this.$store.dispatch('official/changeIsShowSlide', true)

        this.hasPackage = (getHasPackage() === 'true')
        if (this.hasPackage === false) {
          var that = this;
          //未开通套餐时，点击任何菜单都是跳转到激活续费页面
          // 弹窗提示
          // Modal.warning({
          //   title: '提示',
          //   content: '您还未购买套餐类型！请先购买',
          //   onOk: function() {
          //     that.$router.push('/pc/official/dialog').catch(err => {
          //       err
          //     })
          //     that.$store.dispatch('nav/changeOfficialAccountActiveIndex', 5)
          //   }
          // })
            that.$router.push('/pc/official/dialog').catch(err => {
                err
            })
            that.$store.dispatch('nav/changeOfficialAccountActiveIndex', 5)
          return;
        } else {
          this.$store.dispatch('nav/changeOfficialAccountActiveIndex', activeIndex)
          this.$router.push(url).catch(err => {
            err
          })
        }
      }
    }
  }
</script>

<style scoped>
  .slide {
    width: 4.4rem;
    background: #fdfdfd;
  }

  .slide-wrapper {
    list-style: none;
  }

  .slide-wrapper li {
    width: 100%;
    height: 1rem;
    text-align: center;
  }

  .slide-wrapper li .slide-item {
    display: flex;
    padding: 0 0.5rem;
    height: 100%;
    cursor: pointer;
    align-items: center;
    color: #666666;
    font-size: 14px;
  }

  .slide-wrapper li .slide-item .item-left {
    width: 0.4rem;
    float: left;
    margin-right: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/official/SildeNav.vue